export const URL_QR_PRODUCT_PATH = "/products/url-qr";

export const HOME_QR_TYPE_ROUTE_KEYS = [
  "url",
  "wifi",
  "pdf",
  "vcard",
  "text",
  "email",
  "sms",
  "cloudLinks"
];

const PRODUCT_LANGUAGE_POLICY = {
  [URL_QR_PRODUCT_PATH]: ["en", "vi", "ja", "th", "zh-TW", "ko", "id", "ms", "fr"]
};

const normalizeLanguage = (language) => {
  const raw = String(language || "").trim().toLowerCase().replace(/_/g, "-");
  if (raw === "zh-tw") return "zh-TW";
  if (raw === "ind") return "id";
  if (raw === "vn") return "vi";
  return raw.split("-")[0];
};

const normalizePath = (pathname) =>
  String(pathname || "/").split("?")[0].replace(/\/+$/, "") || "/";

export const getProductSupportedLanguages = (pathname) =>
  PRODUCT_LANGUAGE_POLICY[normalizePath(pathname)] || null;

export const isProductPathSupportedForLanguage = (pathname, language) => {
  const supportedLanguages = getProductSupportedLanguages(pathname);
  if (!supportedLanguages) return true;
  return supportedLanguages.includes(normalizeLanguage(language));
};

export const filterProductRoutesForLanguage = (routes, language) =>
  (Array.isArray(routes) ? routes : []).filter((route) =>
    isProductPathSupportedForLanguage(route?.path, language)
  );

export const getHomeQrTypeProductPath = (routes, index, language) => {
  const routeList = Array.isArray(routes) ? routes : [];
  const routeKey = HOME_QR_TYPE_ROUTE_KEYS[index];
  const route = routeList.find((item) => item?.key === routeKey);

  if (route && isProductPathSupportedForLanguage(route.path, language)) {
    return route.path;
  }

  return (
    routeList.find((item) => item?.key === "dynamic")?.path ||
    "/products/dynamic-qr"
  );
};

export const getProductFallbackLanguage = (pathname) =>
  getProductSupportedLanguages(pathname)?.[0] || null;
